import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { authMe, getToken, setToken as saveToken, clearToken } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = authed
  const [checking, setChecking] = useState(true);

  const refresh = useCallback(async () => {
    if (!getToken()) { setUser(false); setChecking(false); return; }
    try {
      const u = await authMe();
      setUser(u);
    } catch {
      clearToken();
      setUser(false);
    } finally {
      setChecking(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = (token, u) => { saveToken(token); setUser(u); };
  const logout = () => { clearToken(); setUser(false); };

  return (
    <AuthContext.Provider value={{ user, checking, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
